export const outdoorLocationQuestions = [
  {
    questionNumber: 1,
    choices: {
      A: "A group of people is gathered around a fountain.",
      B: "A gardener is trimming the bushes.",
      C: "A bench is placed along the pathway.",
      D: "A street musician is performing near the trees.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 길을 따라 벤치가 설치되어 있음\n" +
      "오답 설명: (A) 분수대 주위에 사람들이 모여있는 모습은 보이지 않음, (B) 정원사가 덤불을 손질하는 모습은 보이지 않음, (D) 거리 음악가가 연주하는 모습은 보이지 않음",
  },
  {
    questionNumber: 2,
    choices: {
      A: "A cyclist is riding along the pathway.",
      B: "A park bench is placed under a tree.",
      C: "A streetlamp is being repaired.",
      D: "Trees are growing along the path.",
    },
    incorrectAnswers: ["A", "B", "C"],
    explanation:
      "정답 설명: (D) 길을 따라 나무들이 자라고 있음\n" +
      "오답 설명: (A) 자전거를 타는 사람은 보이지 않음, (B) 벤치가 보이지 않음, (C) 가로등이 수리되는 모습은 보이지 않음",
  },
  {
    questionNumber: 3,
    choices: {
      A: "A cyclist is riding along the pathway.",
      B: "A streetlamp is being installed.",
      C: "A pedestrian is walking between the trees.",
      D: "Lamp posts line the pathway.",
    },
    incorrectAnswers: ["A", "B", "C"],
    explanation:
      "정답 설명: (D) 길을 따라 가로등이 설치되어 있음\n" +
      "오답 설명: (A) 자전거를 타는 사람은 보이지 않음, (B) 가로등이 설치되는 중인 모습은 보이지 않음, (C) 보행자가 걷는 모습은 보이지 않음",
  },
  {
    questionNumber: 4,
    choices: {
      A: "Flowers are being planted in the yard.",
      B: "Plants are growing in a garden bed.",
      C: "A wooden fence is being repaired.",
      D: "The grass is being mowed.",
    },
    incorrectAnswers: ["A", "C", "D"],
    explanation:
      "정답 설명: (B) 정원 화단에 식물들이 자라고 있음\n" +
      "오답 설명: (A) 꽃이 심어지는 중인 모습은 보이지 않음, (C) 울타리가 수리되는 모습은 보이지 않음, (D) 잔디가 깎이는 중인 모습은 보이지 않음",
  },
  {
    questionNumber: 5,
    choices: {
      A: "Trees are being trimmed in the garden.",
      B: "The fountain is not operating.",
      C: "A decorative fountain is flowing with water.",
      D: "Benches are arranged around the fountain.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 장식용 분수대에서 물이 흐르고 있음\n" +
      "오답 설명: (A) 나무를 트리밍하는 사람이 보이지 않음, (B) 분수대가 물을 분사하며 작동하는 중임, (D) 분수대 주변에 벤치가 배치된 모습은 보이지 않음",
  },
  {
    questionNumber: 6,
    choices: {
      A: "Some people are sitting on the benches.",
      B: "A bicycle is leaning against a bench.",
      C: "The benches are occupied by visitors.",
      D: "Benches are arranged along the path.",
    },
    incorrectAnswers: ["A", "B", "C"],
    explanation:
      "정답 설명: (D) 벤치들이 길을 따라 배치되어 있음\n" +
      "오답 설명: (A) 벤치에 앉아있는 사람이 없음, (B) 자전거가 보이지 않음, (C) 벤치에 방문객이 없음",
  },
  {
    questionNumber: 7,
    choices: {
      A: "Children are playing on the playground.",
      B: "A group of people is gathered near the swings.",
      C: "The playground equipment is unoccupied.",
      D: "A worker is repairing the play structures.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 놀이터 시설물이 비어있음\n" +
      "오답 설명: (A) 놀이터에 아이들이 없음, (B) 그네 근처에 모여있는 사람들이 없음, (D) 놀이 시설을 수리하는 작업자가 없음",
  },
  {
    questionNumber: 8,
    choices: {
      A: "A man is washing a car.",
      B: "Cars are parked along the street.",
      C: "Traffic is moving through an intersection.",
      D: "A bus is approaching the parked cars.",
    },
    incorrectAnswers: ["A", "C", "D"],
    explanation:
      "정답 설명: (B) 차량들이 길가에 주차되어 있음\n" +
      "오답 설명: (A) 차를 씻는 사람이 없음, (C) 교차로가 없고 차량이 주행 중이 아님, (D) 버스가 보이지 않음",
  },
  {
    questionNumber: 9,
    choices: {
      A: "Cars are parked along the street.",
      B: "Some people are crossing the road.",
      C: "Trees are planted along the sidewalk.",
      D: "A bus is stopped at the traffic light.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 나무들이 인도 옆에 줄지어 심어져 있음\n" +
      "오답 설명: (A) 주차된 차량이 없음, (B) 도로를 건너는 보행자가 없음, (D) 버스와 신호등이 보이지 않음",
  },
  {
    questionNumber: 10,
    choices: {
      A: "The building has been completed.",
      B: "A building is under construction.",
      C: "Workers are standing on the scaffolding.",
      D: "A truck is parked in front of the site.",
    },
    incorrectAnswers: ["A", "C", "D"],
    explanation:
      "정답 설명: (B) 건물이 공사 중임\n" +
      "오답 설명: (A) 건물이 완공되지 않고 공사 중임, (C) 비계에 작업자가 없음, (D) 현장 앞에 트럭이 없음",
  },
  {
    questionNumber: 11,
    choices: {
      A: "A person is sitting on the bench.",
      B: "Some bicycles are leaning against a bench.",
      C: "A car is parked near the bench.",
      D: "The bench is placed next to a river.",
    },
    incorrectAnswers: ["A", "C", "D"],
    explanation:
      "정답 설명: (B) 자전거들이 벤치에 기대어 있음\n" +
      "오답 설명: (A) 벤치에 앉아있는 사람이 없음, (C) 벤치 근처에 주차된 자동차가 없음, (D) 벤치 옆에 강이 없음",
  },
  {
    questionNumber: 12,
    choices: {
      A: "A bridge is spanning across the river.",
      B: "Boats are floating under the bridge.",
      C: "Pedestrians are walking on the bridge.",
      D: "The bridge is under construction.",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "정답 설명: (A) 다리가 강을 가로지르고 있음\n" +
      "오답 설명: (B) 다리 아래에 보트가 없음, (C) 다리 위에 보행자가 없음, (D) 다리가 공사 중이 아님",
  },
  {
    questionNumber: 13,
    choices: {
      A: "Some of the umbrellas have been folded down.",
      B: "A few people are sunbathing on the lounge chairs.",
      C: "Umbrellas and lounge chairs are lined up.",
      D: "The umbrellas are providing shade for the people.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 해변에 파라솔과 선베드가 줄지어 있음\n" +
      "오답 설명: (A) 모든 파라솔이 펼쳐져 있음, (B) 선베드에 누워있는 사람이 없음, (D) 파라솔 아래 사람이 없음",
  },
  {
    questionNumber: 14,
    choices: {
      A: "A tractor is plowing the field.",
      B: "A windmill is standing near a barn.",
      C: "Some cows are grazing in the pasture.",
      D: "A worker is repairing the fence.",
    },
    incorrectAnswers: ["A", "C", "D"],
    explanation:
      "정답 설명: (B) 풍차가 헛간 근처에 서 있음\n" +
      "오답 설명: (A) 밭을 가는 트랙터가 없음, (C) 초원에서 풀을 뜯는 소가 없음, (D) 울타리를 수리하는 작업자가 없음",
  },
  {
    questionNumber: 15,
    choices: {
      A: "A farmer is driving the tractor.",
      B: "The barn doors are wide open.",
      C: "A tractor is parked near the barn.",
      D: "The cow is standing next to the tractor.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 트랙터가 헛간 근처에 주차되어 있음\n" +
      "오답 설명: (A) 트랙터를 운전하는 농부가 없음, (B) 헛간 문이 완전히 열려있지 않음, (D) 소가 트랙터 근처에 없음",
  },
  {
    questionNumber: 16,
    choices: {
      A: "A farmer is standing next to the tractor.",
      B: "The tractor is parked in the field.",
      C: "A tractor is plowing the field.",
      D: "Crops are being harvested.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 트랙터가 논밭을 갈고 있음\n" +
      "오답 설명: (A) 농부가 서 있지 않고 트랙터를 운전 중임, (B) 트랙터가 주차된 것이 아니라 작업 중임, (D) 수확이 아닌 경작 작업을 하고 있음",
  },

  {
    questionNumber: 17,
    choices: {
      A: "Water is shooting up from the ground.",
      B: "People are playing in the fountain.",
      C: "The umbrellas are open over the outdoor seating.",
      D: "A street performer is entertaining a crowd.",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "정답 설명: (A) 바닥 분수에서 물이 뿜어져 나오고 있음\n" +
      "오답 설명: (B) 분수에서 물놀이하는 사람이 없음, (C) 야외 테이블의 파라솔이 접혀있음, (D) 거리 공연자와 구경하는 사람들이 없음",
  },
  {
    questionNumber: 18,
    choices: {
      A: "A monument is standing in the square.",
      B: "People are gathered around the statue.",
      C: "Some bicycles are leaning against the monument.",
      D: "A fountain is spraying water near the building.",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "정답 설명: (A) 기념비가 광장에 서 있음\n" +
      "오답 설명: (B) 기념비 주변에 모여있는 사람이 없음, (C) 기념비에 기대어 있는 자전거가 없음, (D) 건물 근처에 분수가 없음",
  },
  {
    questionNumber: 19,
    choices: {
      A: "A bicycle is being repaired near the café.",
      B: "Tables and chairs are arranged outside the café.",
      C: "The umbrellas have been closed.",
      D: "A waiter is serving food to the customers.",
    },
    incorrectAnswers: ["A", "C", "D"],
    explanation:
      "정답 설명: (B) 야외 카페에 테이블과 의자가 배치되어 있음\n" +
      "오답 설명: (A) 자전거가 있지만 수리 중이 아님, (C) 파라솔이 닫혀있지 않고 열려있음, (D) 음식을 서빙하는 웨이터가 없음",
  },
  {
    questionNumber: 20,
    choices: {
      A: "A statue is being installed in the square.",
      B: "The outdoor café is closed for the night.",
      C: "Bicycles are lined up along the street.",
      D: "The buildings are illuminated at night.",
    },
    incorrectAnswers: ["A", "B", "C"],
    explanation:
      "정답 설명: (D) 건물들이 밤에 조명으로 밝게 빛나고 있음\n" +
      "오답 설명: (A) 동상이 이미 설치되어 있음, (B) 야외 카페가 영업 중임, (C) 자전거가 줄지어 있지 않음",
  },
  {
    questionNumber: 21,
    choices: {
      A: "Campers are setting up their tents.",
      B: "A bonfire is burning in the middle of the campsite.",
      C: "Trees surround the camping area.",
      D: "People are packing up their camping gear.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 캠핑장 주변이 나무들로 둘러싸여 있음\n" +
      "오답 설명: (A) 텐트를 설치하는 캠퍼들이 없음, (B) 캠프장 중앙에 모닥불이 없음, (D) 캠핑 장비를 정리하는 사람들이 없음",
  },
  {
    questionNumber: 22,
    choices: {
      A: "The picnic tables are placed inside a building.",
      B: "The firewood is burning in a campfire.",
      C: "Trees are being chopped down.",
      D: "A row of trees stands behind the benches.",
    },
    incorrectAnswers: ["A", "B", "C"],
    explanation:
      "정답 설명: (D) 벤치 뒤로 나무들이 줄지어 서있음\n" +
      "오답 설명: (A) 피크닉 테이블이 건물 안에 있지 않음, (B) 모닥불이나 장작불이 타고 있지 않음, (C) 나무들이 베어지고 있지 않음",
  },
  {
    questionNumber: 23,
    choices: {
      A: "A car is passing through a tunnel.",
      B: "The road passes between houses.",
      C: "People are crossing the street.",
      D: "A traffic light is mounted on a pole.",
    },
    incorrectAnswers: ["A", "C", "D"],
    explanation:
      "정답 설명: (B) 도로가 주택가 사이로 지나가고 있음\n" +
      "오답 설명: (A) 터널을 지나가는 차가 없음, (C) 길을 건너는 사람들이 없음, (D) 기둥에 설치된 신호등이 없음",
  },
  {
    questionNumber: 24,
    choices: {
      A: "A river is bordered by tall buildings.",
      B: "The boat is docked along the riverbank.",
      C: "Pedestrians are crossing a bridge over the water.",
      D: "A construction site is visible near the waterfront.",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "정답 설명: (A) 강가를 따라 높은 건물들이 늘어서 있음\n" +
      "오답 설명: (B) 강가에 정박해 있는 배가 없음, (C) 다리를 건너는 보행자들이 없음, (D) 수변 근처에 공사 현장이 보이지 않음",
  },
  {
    questionNumber: 25,
    choices: {
      A: "A bridge is under construction.",
      B: "A ferry is docked at the riverbank.",
      C: "The river is bordered by skyscrapers.",
      D: "Pedestrians are crossing the bridge.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 강가를 따라 고층 빌딩들이 늘어서 있음\n" +
      "오답 설명: (A) 공사 중인 다리가 없음, (B) 강가에 정박해 있는 페리가 없음, (D) 다리를 건너는 보행자들이 없음",
  },
  {
    questionNumber: 26,
    choices: {
      A: "A bicycle rack is mounted on the ground.",
      B: "A person is locking a bicycle to the rack.",
      C: "Several bicycles are lying on the sidewalk.",
      D: "The bike rack is empty",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "정답 설명: (A) 자전거 거치대가 지면에 설치되어 있음\n" +
      "오답 설명: (B) 자전거를 거치대에 잠그고 있는 사람이 없음, (C) 보도에 누워있는 자전거들이 없음, (D) 자전거 거치대가 비어있지 않음",
  },
  {
    questionNumber: 27,
    choices: {
      A: "A cyclist is unlocking a bicycle.",
      B: "People are walking their bikes across the square.",
      C: "A row of benches is placed near the bicycles.",
      D: "Several unattended bicycles are parked at a bike rack.",
    },
    incorrectAnswers: ["A", "B", "C"],
    explanation:
      "정답 설명: (D) 자전거 거치대에 여러 대의 자전거가 세워져 있음\n" +
      "오답 설명: (A) 자전거 잠금장치를 푸는 사람이 없음, (B) 광장을 가로질러 자전거를 끌고 가는 사람들이 없음, (C) 자전거 근처에 설치된 벤치들이 없음",
  },
  {
    questionNumber: 28,
    choices: {
      A: "Clouds are scattered across the sky.",
      B: "A row of streetlights lines the road.",
      C: "Traffic signs are placed along the roadside.",
      D: "A group of people is walking along the road.",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "정답 설명: (A) 하늘에 구름이 흩어져 있음\n" +
      "오답 설명: (B) 도로를 따라 가로등이 늘어서 있지 않음, (C) 도로변에 교통 표지판이 설치되어 있지 않음, (D) 도로를 따라 걷고 있는 사람들이 없음",
  },
];
